import { toast } from "react-toastify";

export const successNotify = (message) => {
    const msg = typeof message === "string" 
        ? message 
        : (message?.response?.data?.message || message?.message || "Operation completed successfully");
    toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    });
};

export const errorNotify = (message) => {
    let msg = "An error occurred";
    if (typeof message === "string") {
        msg = message;
    } else if (message?.response?.data?.message) {
        msg = Array.isArray(message.response.data.message)
            ? message.response.data.message.join(", ")
            : String(message.response.data.message);
    } else if (message?.response?.data?.error) {
        msg = typeof message.response.data.error === "string"
            ? message.response.data.error
            : JSON.stringify(message.response.data.error);
    } else if (message?.response?.data?.msg) {
        msg = String(message.response.data.msg);
    } else if (message?.message) {
        msg = String(message.message);
    }
    toast.error(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    });
};